import React, { useRef, useState } from "react"
import { useParams } from "react-router"
import { useHistory } from 'react-router-dom'

import Title from '@base/Title'
import Toast from '@base/Toast'
import { ProcessoResolver } from "@helpers/ProcessoHelper"
import CartoesTableView from "@pages/Escola/Cartoes/componentes/CartoesTableView"
import QuantitativoTratamentoNomeDuplicado from "./QuantitativoTratamentoNomeDuplicado";
import DoneAllIcon from '@material-ui/icons/DoneAll';

export const DashboardTratamentoNomesDuplicados = () => {
  const toastRef = useRef(null);
  const history = useHistory();
  const params = useParams();
  const processo = ProcessoResolver(params.processo);

  const [, setStatusSelecionado] = useState();
  const [horaUltimoRefresh, setHoraUltimoRefresh] = useState();

  const limparFiltros = () => {
    setStatusSelecionado("");
  }

  const columns = [
    { label: 'id', name: 'id', hidden: true, key: true },
    {
      label: 'Origem do Cartão',
      name: 'origem',
      filter: 'objetoPostal.origem',
      func: (objColuna, objLinha) => objColuna ? objColuna.descricao : "",
      key: false
    },
    { label: 'Código', name: 'codigo', key: false },
    {
      label: 'Nome',
      name: 'nomeAluno',
      filter: 'aluno.nome',
      func: (objColuna, objLinha) => <> {objColuna}{objLinha.tratamentoNomeDuplicado && objLinha.tratamentoNomeDuplicado.nomeSubstituido ?
        <span style={{
          display: "block",
          fontSize: 11,
          color: "#999"
        }}>{objLinha.tratamentoNomeDuplicado.nomeSubstituido}</span> : ""}</>,
      key: false
    },
    {
      label: 'Origem do Problema',
      name: 'tipoTratamentoOrigem',
      filter: 'tratamentoNome.origemProblema',
      func: (objColuna, objLinha) => <> {objLinha.tratamentoNomeDuplicado ? (objLinha.tratamentoNomeDuplicado.origem === "OUTRO" ? <>{objLinha.tratamentoNomeDuplicado.origem}<span
        style={{
          display: "block",
          fontSize: 11,
          color: "#999"
        }}>{objLinha.tratamentoNomeDuplicado.descricaoOrigemOutro}</span></> : objLinha.tratamentoNomeDuplicado.origem) : "--"}</>,
      key: false
    },
    {
      label: 'Status do Tratamento',
      name: 'statusTratamentoNomeDuplicado',
      filter: 'tratamentoNome.status',
      func: (objColuna, objLinha) => <> {objLinha.tratamentoNomeDuplicado ? objLinha.tratamentoNomeDuplicado.statusLabel : ""} {objLinha.tratamentoNomeDuplicado && objLinha.tratamentoNomeDuplicado.responsavel ?
        <span
          style={{ display: "block", color: "#999", fontSize: 11 }}>{objLinha.tratamentoNomeDuplicado.responsavel}</span> : ""}</>,
      key: false
    },
    {
      label: 'Tratamento', name: 'codigo', key: false, ordering: false, func: (c, l) => {
        if (l == null) {
          return "--"
        } else {
          return <DoneAllIcon color={'primary'} style={{ cursor: 'pointer' }}
            onClick={() => redirecionarParaPaginaDeTratamento(l.id, l.codigo)} />;
        }
      }
    }

  ];

  const cartoesTableViewRef = useRef(null);

  const atualizaFiltros = (tipo, status) => {
    if (cartoesTableViewRef.current) {
      cartoesTableViewRef.current.atualizarFiltrosQuantitativosNomeDuplicado(tipo, status);
    } else {
      console.log("current null");
    }
  }

  function redirecionarParaPaginaDeTratamento(id, codigo) {
    history.push({
      pathname: `/${processo.id}/tratamentosDeNomesDuplicados/${codigo}`,
      state: {
        id: id
      }
    });
  }

  return (
      <>
        <Toast ref={toastRef} />
        <Title>Tratamento de Nomes Duplicados na escola</Title>

        <QuantitativoTratamentoNomeDuplicado aoClicarEmQuantitativo={atualizaFiltros}
          refresh={horaUltimoRefresh}
          processo={processo.id} />

        <CartoesTableView
          ref={cartoesTableViewRef}
          refresh={horaUltimoRefresh}
          exibeFiltro={true}
          exibeFiltroTratamentoNomeDuplicado={true}
          exibeActions={false}
          mensagemInformativaAoDescartarCartao={"Ao descartar o cartão a pendência de nome duplicado será automaticamente atualizada para 'Resolvida'"}
          colunas={columns}
          defaultOrderBy="nomeAluno"
          processo={processo.id}
          somenteComTratamentoNomeDuplicado={true}
          sessionStorage={"filtroTelaNomesDuplicados"}
          aoAtualizarStatusTratamentoNomeDuplicado={(cartao, cartoes, setCartoes, filtroStatus) => {

            let cartoesTemp = cartoes.map(c => {

              if (c.id === cartao.data.id) {
                if (filtroStatus !== undefined && filtroStatus !== "") {
                  if (filtroStatus !== cartao.data.statusTratamentoNomeDuplicado) {
                    return null;
                  } else {
                    return cartao.data;
                  }
                } else {
                  return cartao.data;
                }
              } else {
                return c;
              }

            });

            setCartoes(cartoesTemp.filter(cartao => cartao != null));
            setHoraUltimoRefresh(new Date());
          }
          }
          motivosDescarteDisponiveis={() => {
            return [{ value: 'TRATAMENTO_NOME_DUPLICADO', label: 'Tratamento de Nome na Escola' }]
          }}
          aoDescartarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
          aoRestaurarCartao={(cartao) => setHoraUltimoRefresh(new Date())}
          aoLimparFiltro={limparFiltros} />
      </>
    );
  }

  export default DashboardTratamentoNomesDuplicados;
